
import _ from "lodash";

export const formattedCurrency = (number: number) => _.toNumber(number).toLocaleString("en-US", {
    style: "currency",
    currency: "USD"
  });